import { Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { EmptyIndicator } from '../../form/empty-indicator'
import { formatTime } from '../utils/tom-table.utils'

interface Props {
  date: Date | string | null | undefined
  timeStyle?: 'short' | 'full' | 'long' | 'medium'
}
export const TableDateCell = observer(({ date, timeStyle }: Props) => {
  return (
    <Stack>
      <Typography variant={'subtitle2'}>
        {date ? dayjs(date).format('l') : EmptyIndicator}
      </Typography>
      <Typography variant={'body2'} color={'secondary'}>
        {formatTime(date, timeStyle) ?? EmptyIndicator}
      </Typography>
    </Stack>
  )
})
